import { render, staticRenderFns } from "./TargetingPerformance.vue?vue&type=template&id=2890661c&scoped=true&"
import script from "./TargetingPerformance.vue?vue&type=script&lang=ts&"
export * from "./TargetingPerformance.vue?vue&type=script&lang=ts&"
import style0 from "./TargetingPerformance.vue?vue&type=style&index=0&id=2890661c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2890661c",
  null
  
)

export default component.exports